import React, { useEffect, useState } from 'react';
import styles from './AdminClubSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { resetClubSingle, resetUpdateClub } from '../../../redux/slices/app.slice';
import { clubSingle } from '../../../redux/actions/app/clubSingle';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';
import { updateClub } from '../../../redux/actions/app/updateClub';

const getDateFromTimeString = (time) => {
  if (!time) {
    return '';
  }
  // 1. Создаем dayjs объект с текущей датой
  let datetime = dayjs();

  // 2. Разбиваем строку времени на часы и минуты
  const [hours, minutes] = time.split(':').map(Number);

  // 3. Устанавливаем время
  datetime = datetime.hour(hours).minute(minutes).second(0).millisecond(0).toDate();

  return datetime;
};

const AdminClubSingle = () => {
  const data = [
    [
      {
        label: 'Лого',
        type: 'image',
        name: 'logo',
        width: '200px',
      },
      [
        {
          label: 'Название',
          type: 'text',
          name: 'name',
        },

        { required: false, label: 'Адрес', type: 'text', name: 'address' },
      ],
    ],
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ club: { images, tables, clubTags, averageBill, menuLink, siteLink, yandexLink, closeTime, openTime, address, name, logo, cityId, email, phone }, cities, tags }) => {
    const commonTags = tags.filter((item) => item.isCommon)?.map((item) => ({ value: item.id, label: item.name }));
    const otherTags = tags.filter((item) => !item.isCommon)?.map((item) => ({ value: item.id, label: item.name }));
    let tablesFields = [];
    let tablesValue = {};
    [...tables]
      ?.sort((a, b) => a.tableTypeId.localeCompare(b.tableTypeId))
      ?.map((table) => {
        tablesFields.push({
          disabled: true,
          label: `Стол - ${table?.type?.name}`,
          type: 'string',
          name: `tables.${table.id}`,
        });
        tablesValue = { ...tablesValue, [table.id]: table?.quantity };
      });

    const fields = [
      { label: 'Фото', type: 'gallery', name: 'images' },
      [
        {
          label: 'Город',
          type: 'select',
          name: 'cityId',
          options: cities?.map((club) => ({ value: club?.id, label: club?.name })),
        },
      ],

      [
        { required: false, label: 'Телефон', type: 'number', name: 'phone', format: '+7 (###) ### ## ##' },
        {
          required: false,
          label: 'Email',
          type: 'text',
          name: 'email',
          rules: {
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Неверный формат почты',
            },
          },
        },
      ],
      [
        {
          label: 'Часы работы, от',
          type: 'time',
          name: 'openTime',
        },
        {
          label: 'Часы работы, до',
          type: 'time',
          name: 'closeTime',
        },
      ],
      {
        required: false,
        label: 'Ссылка на меню или ЯндексКарты',
        type: 'text',
        name: 'menuLink',
      },
      { required: false, label: 'Ссылка на Яндекс Карты (для отображения рейтинга)', type: 'text', name: 'yandexLink' },
      { required: false, label: 'Сайт', type: 'text', name: 'siteLink' },
      { required: false, label: 'Средний чек', type: 'number', name: 'averageBill' },
      [
        {
          label: 'Основние',
          type: 'checkbox',
          name: 'tags',
          options: commonTags,
        },
        {
          label: 'Дополнительно',
          type: 'checkbox',
          name: 'tags',
          options: otherTags,
        },
      ],
      tablesFields,
    ];

    let checkedTags = {};
    clubTags?.map((tag) => {
      checkedTags = { ...checkedTags, [tag?.clubTagsId]: true };
    });
    setFields([...data, ...fields]);
    return { logo, cityId, email, phone, name, address, openTime: getDateFromTimeString(openTime), closeTime: getDateFromTimeString(closeTime), menuLink, siteLink, yandexLink, averageBill, tags: checkedTags, tables: tablesValue, images };
  };
  const deleteProps = { successText: 'Клуб удален', confirmTitle: `Вы уверены что хотите удалить клуб`, status: 'DELETED' };
  const blockProps = { successText: 'Клуб заблокирован', confirmTitle: `Вы уверены что хотите заблокировать клуб`, status: 'BLOCKED' };
  const unblockProps = { successText: 'Клуб разблокирован', confirmTitle: `Вы уверены что хотите разблокировать клуб`, status: 'ACTIVE' };

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    updateClub: { data: updateClubData, loading: updateClubLoading },
  } = useSelector((state) => state.app);
  const navigate = useNavigate();
  useEffect(() => {
    if (updateClubData) {
      toast.success('Клуб обновлен');
      navigate('/admin/clubs');
      dispatch(resetUpdateClub());
    }
  }, [updateClubData]);

  return (
    <>
      <AdminSinglePage
        onSubmit={(data) => {
          const { images, logo, tags, tables, ...otherData } = data;
          const formatData = { ...otherData, clubId: id, closeTime: dayjs(data.closeTime).format('HH:mm').toString(), openTime: dayjs(data.openTime).format('HH:mm').toString(), phone: data?.phone ? `+${data?.phone.replace(/\D/g, '')}` : null };
          console.log(formatData);

          dispatch(updateClub(formatData));
        }}
        reset={resetClubSingle}
        fetch={clubSingle}
        sliceName={'app'}
        actionName={'clubSingle'}
        onFormatData={onFormatData}
        fields={fields}
        isSave
        pathList="/admin/clubs"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'club'}
        type={'CLUB'}
      />
      {updateClubLoading && <Loading />}
    </>
  );
};

export default AdminClubSingle;
